let enabled = document.querySelector('.cinema__animation') && typeof TimelineMax !== 'undefined'

if(enabled){
	// scroll up on desktop refresh
	window.onbeforeunload = function () {
	  window.scrollTo(0, 0)
	}

	// scroll up on mobile safari refresh
	window.onload = function() {
	 setTimeout (function () {
	  scrollTo(0,0);
	 }, 100)
	}

	let mobile = window.innerWidth <= 768

	var cinema = document.querySelector('.cinema')

	var text = document.querySelector('.cinema__text')
	var ring = document.querySelector('.cinema__ring')
	var ball = document.querySelector('.cinema__ball')
	var logo = document.querySelector('.cinema__logo svg')
	var logoClaim = document.querySelector('.cinema__claim')

	var string = text.getAttribute('data-string')
	var stringB = text.getAttribute('data-string-next')
	var stringSpeed = 60
	var duration = (string.length * stringSpeed / 1000) + (stringB.length * stringSpeed / 1000) + 0.25

	var tl = new TimelineMax()

	tl.eventCallback("onStart", function() {
		document.body.classList.add('cinema-running', 'cinema-lockscroll')
	});

	tl.eventCallback("onComplete", function() {
		document.body.classList.remove('cinema-running')
		document.body.classList.add('cinema-finished')
	});

	tl.to(text, {
		duration: duration,
	  x: function(index, target, targets) {

	    var init = new TypeIt(".cinema__text", {
	    	speed: stringSpeed,
			}).type(string).pause(900).empty().type(stringB).go().destroy(false)
	  },
	  onComplete: function() {
	  	$(text).find('.ti-cursor').addClass('cinema-ti-cursor-hide')
	  }
	})

	.to(text, {
		duration: 1.5,
		opacity: 0,
	}, "+=1.2")

	tl.to(ring, {
		duration: 1.5,
		opacity: 1,
		"box-shadow": "0px 0px 50px 7px #0099A9 inset, 0px 0px 50px 7px #0099A9",
		clearProps: 'box-shadow',
		onComplete: function() {
			ring.classList.add('run')
		}
	}, "-=2")

	tl.to(ring, {
		duration: 1.3,
		"border-color": "#0099A9"
	})

	tl.addLabel("dots", "-=1.5")

	tl.to(ball, {
		duration: 1,
		opacity: .4
	}, "-=2")

	.to(logo, {
		duration: 2,
		opacity: 1,
		scale: 1,
	}, "-=1.5")

	.to(ball, {
		duration: 3,
		opacity: 0,
	}, "-=2")

	if(!mobile){
		tl.to(ring, {
			duration: 1.2,
			x: getRingPos().x,
			y: getRingPos().y,
			scale: 0.038,
			backgroundColor: '#fff'
		}, "-=2")

		.to(logo, {
			duration: 1.2,
			x: getLogoPos().x,
			y: getLogoPos().y,
			width: 110,
			height: 64,
			onComplete: function() {
				document.body.classList.add('cinema-showControls')
			}
		}, "-=2")

		.to(logoClaim, {
			duration: .5,
			y: 0
		}, "-=0.5")

		tl.to(".cinema__dots span.dot1", {keyframes: [
		  {duration: .75, opacity: .3, x : 250, y : 200, scale: 2},
		  {duration: .75, opacity: 0, x : 500, y : 400, scale: 3},
		]}, "dots")

		.to(".cinema__dots span.dot2", {keyframes: [
		  {duration: .75, opacity: .3, x : 420, y : 180, scale: 2},
		  {duration: .75, opacity: 0, x : 840, y : 360, scale: 3},
		]}, "dots-=.4")

		.to(".cinema__dots span.dot3", {keyframes: [
		  {duration: .75, opacity: .3, x : -200, y : 200, scale: 2},
		  {duration: .75, opacity: 0, x : -400, y : 400, scale: 3},
		]}, "dots-=.2")

		.to(".cinema__dots span.dot4", {keyframes: [
		  {duration: .75, opacity: .3, x : -170, y : -240, scale: 2},
		  {duration: .75, opacity: 0, x : -540, y : -480, scale: 3},
		]}, "dots+=0.2")

		.to(".cinema__dots span.dot5", {keyframes: [
		  {duration: .75, opacity: .3, x : -620, y : -50, scale: 2},
		  {duration: .75, opacity: 0, x : -1240, y : -100, scale: 3},
		]}, "dots+=0.1")

		.to(".cinema__dots span.dot6", {keyframes: [
		  {duration: .75, opacity: .3, x : 150, y : -250, scale: 2},
		  {duration: .75, opacity: 0, x : 300, y : -500, scale: 3},
		]}, "dots+=0.1")

		var nextAnimationDelay = '-=0.3'
	}else {

		tl.to(ring, {
			duration: .6,
			scale: 0.8,
			opacity: 0
		}, "-=1.5")

		.to(logo, {
			duration: .6,
			scale: 0.7,
			opacity: 0
		}, "-=1.5")

		.to(cinema, {
			duration: 1,
			x: function(index, target, targets) {
				document.body.classList.add('cinema-showControls')
				document.body.classList.add('cinema-showLogo')
			}
		}, '-=1.5')

		var nextAnimationDelay = '-=1.1'
	}

	tl.to(cinema, {
		duration: 1.75,
		x: function(index, target, targets) {
			document.body.classList.remove('cinema-lockscroll')

			document.body.classList.add('cinema-showCds')

			if(mobile){
				document.body.classList.add('cinema-showCdsFill')
			}
		}
	}, '-=0.5')

	tl.to(cinema, {
		duration: 1,
		x: function(index, target, targets) {
			document.body.classList.add('cinema-showShadows')
		}
	}, '-=1.5')

	if(!mobile){
		tl.to(cinema, {
			duration: 1.2,
			x: function(index, target, targets) {
				document.body.classList.add('cinema-showCdsFill')
			}
		}, '-=1.2')

		.to(cinema, {
			duration: 2,
			x: function(index, target, targets) {
				document.body.classList.add('cinema-showStars')
			}
		}, '-=.5')
	}

	window.addEventListener('resize', function() {
		document.body.classList.add('cinema-resized')
		logo.classList.add('hide')
		ring.classList.add('hide')
	})

	function getLogoPos() {
		let $current = $('.cinema__logo')
		let $real = $('.sticky__logo')

		let currentOffset = $current.offset()
		let realOffset = $real.offset()

		return {
			x : (realOffset.left - currentOffset.left - 25.5).toFixed(),
			y : (realOffset.top - currentOffset.top - 5).toFixed()
		}
	}

	function getRingPos() {
		let $current = $('.cinema__ring')
		let $real = $('.sticky__logo')

		let currentOffset = $current.offset()
		let realOffset = $real.offset()

		return {
			x : realOffset.left - currentOffset.left - 300 + 128,
			y : realOffset.top - currentOffset.top - 288
		}
	}
}
